export const ACTION = {
    GET_INFORMATION_DETAIL_CONTENT: 'GET_INFORMATION_DETAIL_CONTENT',
}